import { render, staticRenderFns } from "./c3CustomerFeedback.vue?vue&type=template&id=5a4241f2"
import script from "./c3CustomerFeedback.vue?vue&type=script&lang=js"
export * from "./c3CustomerFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports